import React from "react";

const CloudAndPlatforms = () => {
  return (
    <div className="skills_content">
      <h3 className="skills_title">Cloud &amp; Platforms</h3>

      <div className="skills_box">
        <div className="skills_group">
          <div className="skills_data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills_name">Azure Blob Storage</h3>
            </div>
          </div>

          <div className="skills_data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills_name">Azure Event Grid</h3>
            </div>
          </div>

          <div className="skills_data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills_name">Azure Foundry</h3>
            </div>
          </div>

          <div className="skills_data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills_name">AWS S3</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloudAndPlatforms;
